module.exports = __webpack_public_path__ + "img/img-card.3a98be4.png";